import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { 
            Dialog, 
            DialogContent, 
            DialogContentText, 
            Typography,
            Grid,
            Button,
            TextField 
        } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    textField: {
        width: '100%',
    },
    margin: {
        margin: theme.spacing(1),
        textAlign : "center"
    },
    buttonSubmit: {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
    },
    buttonRefresh: {
        color : 'white',
        backgroundColor : '#6878f2'
    },
    buttonCancel: {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
    
    },
    dialogPaper: {
        height : '400px'
    },
    iconRefresh : {
        [theme.breakpoints.up('xs')]: {
            width: '45vw',
            height: '7vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('sm')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('md')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('lg')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('xl')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        
    },
    textQuestion : {
        [theme.breakpoints.up('xs')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        
    },
    textButtons : {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        
    },
    submit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        borderLeft: '3px solid #0073D2',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        //fontFamily: 'Roboto-medium',
        "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid #0073D2',
        }
    },
}));

const FormQuestionDialog = props => {

    //console.log(props)

    const classes = useStyles();

    const {
        questionSelected, 
        openDialog,
        onCloseDialogQuestion,
        formErrors,
        answer,
        handleChangeAnswer,
        handleSubmitQuestion
    } = props;

    const isValid = answer.length > 0 && !formErrors.answer

    return (
        <Dialog
            open={ openDialog }
            onClose={ onCloseDialogQuestion }
            fullWidth={true}
            maxWidth= 'lg'
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper : classes.dialogPaper}}
        >
            <DialogContent>

                <DialogContentText id="alert-dialog-description" align="center">
                    {'Conteste la siguiente pregunta de seguridad.' }
                </DialogContentText>

            
                    <Grid container spacing={3}>
                        
                        <Grid item xs={12} md={12} lg={12} xl={12} className = {classes.margin}>
                            <Typography component="h6" variant="h6" align = "center" className = {classes.textQuestion}>
                                {(questionSelected.question) ? questionSelected.question : ""}
                            </Typography>

                        </Grid>
                        {/* <Grid item xs={12} md={12} lg={12} xl={12} className = {classes.margin}>
                            <IconButton aria-label="delete"  onClick = {handleRefreshQuestion}>
                                <RefreshIcon className = {classes.iconRefresh}/>
                            </IconButton>
                        </Grid> */}
                        <Grid item xs={12} md={12} lg={12} xl={12}>
                            <TextField
                                fullWidth
                                label="Respuesta"
                                name="answer"
                                placeholder="Respuesta"
                                margin="normal"
                                type = "text"
                                autoComplete="off"
                                value={answer || ""}
                                onChange={(e) => handleChangeAnswer(e.target.value)}
                                required
                                inputProps = { {style: { 'textTransform': 'uppercase'}} }
                                error={!!formErrors.answer}
                                helperText={formErrors.answer}
                                InputLabelProps= { { style: { color: '#000000'} } }
                                
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                            <Button 
                                variant="contained" 
                                type="submit"
                                style = {{ width : "140px"}}
                                disabled={ !isValid }
                                className={classes.submit}
                                onClick={handleSubmitQuestion}
                            >
                                { "Aceptar" }
                            </Button>
                        </Grid>
                        
                        <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                            <Button 
                                variant="contained" 
                                style = {{ width : "140px"}}
                                className = {classes.submit}
                                onClick = { onCloseDialogQuestion }
                                
                            >
                                Cancelar
                            </Button>   
                        </Grid>
                    </Grid>
                

            </DialogContent>
        </Dialog>
    )

}

export default FormQuestionDialog